import { graphql } from 'react-apollo';
import { compose, lifecycle } from 'recompose';
import { GetUser } from '../queries/user';
import { withRouter } from 'react-router';
import Routes from '../constants/Routes';

export const withLoggedInRedirect = compose(
  withRouter,
  graphql(GetUser, {
    props: (props: any) => ({
      user: props.data.user,
    }),
  }),
  lifecycle({
    componentDidMount() {
      const { user, history } = this.props as { user: { loggedIn: boolean }; history: any };
      if (user && user.loggedIn) history.push(Routes.main);
    },
  }),
);



// WEBPACK FOOTER //
// ./src/helpers/withLoggedInRedirect.tsx